import { useState } from 'react';
import { Box, Button, Flex } from 'rebass';
import { useTranslation } from 'react-i18next';
import { Label, Input } from '@rebass/forms';

import useCart from 'hooks/usecart';
import { createOrder } from 'hooks/graphql';
import { useMutation } from '@apollo/client';
import { ORDER_TYPE_SELECTION } from 'components/cartprovider';

export default function CheckoutSelection({ studio }) {
  const [cart, dispatch] = useCart();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');

  const [addOrder, { error }] = useMutation(createOrder);

  const submit = async (e) => {
    e.preventDefault();
    const { data } = await addOrder({
      variables: {
        input: {
          studioId: studio.id,
          type: ORDER_TYPE_SELECTION,
          selection: cart.selection,
          email,
        },
      },
    });
    dispatch({
      type: 'set_order_id',
      id: data.createOrder.id,
    });
  };

  const cancel = () => {
    dispatch({ type: 'cancel_order' });
  };

  const close = () => {
    dispatch({ type: 'cancel_order' });
    dispatch({ type: 'empty' });
  };

  return (
    <>
      {!cart.orderId && (
        <Flex
          sx={{
            flexDirection: 'column',
            alignItems: 'center',
          }}
          as="form"
          onSubmit={submit}
        >
          <Box>{t('checkoutbar.selectform')}</Box>
          <Label htmlFor="email" variant="login" mt={3}>
            {t('common.email')}
          </Label>
          <Input
            id="email"
            type="email"
            name="email"
            required
            autoComplete="email"
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && <Box color="red">{error.message}</Box>}
          <Button type="submit" sx={{ marginTop: 2 }}>
            {t('common.submit')}
          </Button>
          <Button variant="link" onClick={cancel} sx={{ marginTop: 2 }}>
            {t('common.cancel')}
          </Button>
        </Flex>
      )}
      {cart.orderId && (
        <Flex
          sx={{
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box sx={{ textAlign: 'center' }}>{t('checkoutbar.selectdone')}</Box>
          <Box sx={{ marginTop: 3 }}>
            <Button variant="link" onClick={close} sx={{ marginTop: 2 }}>
              {t('common.close')}
            </Button>
          </Box>
        </Flex>
      )}
    </>
  );
}
